import moment from 'moment-timezone';

export default {
  /**
   * MLD-6106
   * @see https://chatgpt.com/c/2f17c818-af3a-4bc9-9284-2c88f91bd9d7
   * @returns {string}
   */
  getFriendlyTimezone() {
    // Get the user's time zone
    const userTimeZone = moment.tz.guess();

    // Get the current time in the user's time zone
    const now = moment.tz(userTimeZone);

    // Get the time zone abbreviation
    const timeZoneAbbr = now.format('zz');

    // Determine if daylight saving time is in effect
    const isDST = now.isDST();

    switch (timeZoneAbbr) {
      case 'EDT':
      case 'EST':
        return isDST ? 'Eastern Daylight Time' : 'Eastern Standard Time';
      case 'CDT':
      case 'CST':
        return isDST ? 'Central Daylight Time' : 'Central Standard Time';
      case 'MDT':
      case 'MST':
        return isDST ? 'Mountain Daylight Time' : 'Mountain Standard Time';
      case 'PDT':
      case 'PST':
        return isDST ? 'Pacific Daylight Time' : 'Pacific Standard Time';
      case 'CET':
      case 'CEST':
        return isDST ? 'Central European Summer Time' : 'Central European Time';
      case 'EET':
      case 'EEST':
        return isDST ? 'Eastern European Summer Time' : 'Eastern European Time';
      case 'WET':
      case 'WEST':
        return isDST ? 'Western European Summer Time' : 'Western European Time';
      // Add more cases as needed
      default:
        return `Time Zone: ${userTimeZone}`;
    }
  }
}
